import cn from 'classnames'
import { useFormikContext } from 'formik'

import SearchBar from 'components/SearchBar'

const ListFilters = ({ searchQuery, handleSearch }) => {
  const { submitForm, dirty } = useFormikContext()

  return (
    <div className="venue-settings-filters">
      <button
        className={cn('btn -sm', {
          '-outline': !dirty,
          '-disabled': !dirty,
          '-primary': dirty,
        })}
        type="button"
        onClick={submitForm}
        disabled={!dirty}
      >
        Save
      </button>
      <SearchBar
        handleSearch={handleSearch}
        searchQuery={searchQuery}
      />
    </div>
  )
}

export default ListFilters
